import { GitBranch } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateKycPipelineReport } from '@/src/lib/api/admin-reports'
import type { KycPipelineRow } from '@/src/types/admin/reports'

const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')

const columns: ReportColumn[] = [
  { key: 'month', label: 'เดือน' },
  { key: 'type', label: 'ประเภท' },
  { key: 'status', label: 'สถานะ' },
  { key: 'count', label: 'จำนวน', format: fmtN },
  {
    key: 'avg_review_hours',
    label: 'เฉลี่ย (ชม.)',
    format: (v) => (v == null ? '-' : `${Number(v).toFixed(1)} ชม.`),
  },
]

function extractRows(data: unknown): Record<string, unknown>[] {
  if (Array.isArray(data)) return data as Record<string, unknown>[]
  return []
}

function extractSummary(data: unknown): SummaryStat[] {
  const rows = extractRows(data) as unknown as KycPipelineRow[]
  const approved = rows
    .filter(r => r.status === 'approved')
    .reduce((s, r) => s + Number(r.count ?? 0), 0)
  const rejected = rows
    .filter(r => r.status === 'rejected')
    .reduce((s, r) => s + Number(r.count ?? 0), 0)
  const pending = rows
    .filter(r => r.status === 'pending')
    .reduce((s, r) => s + Number(r.count ?? 0), 0)
  return [
    { label: 'อนุมัติ', value: fmtN(approved) },
    { label: 'ปฏิเสธ', value: fmtN(rejected) },
    { label: 'รอดำเนินการ', value: fmtN(pending) },
  ]
}

export default function AdminReportKyc() {
  return (
    <ReportPageLayout
      title="รายงาน KYC Pipeline"
      description="สถานะ KYC ตามประเภทและเดือน, เวลาเฉลี่ย"
      audience="Operations"
      icon={GitBranch}
      columns={columns}
      fetchFn={generateKycPipelineReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="kyc_pipeline"
    />
  )
}
